module.exports = __webpack_public_path__ + "static/media/UY.910ddeb0.png";